import { useMachineState } from '../app/context';
import { CheckList } from '../components/CheckList';
import { cx } from '../components/cx';
import { BOOT_CHECKS } from '../domain/catalog';
import { TIMING } from '../domain/timing';
import styles from './BootScreen.module.css';
import common from './common.module.css';

export function BootScreen() {
  const { phaseElapsed } = useMachineState();
  const pct = Math.min(100, Math.round((phaseElapsed / TIMING.boot) * 100));

  return (
    <section className={cx(common.screen, styles.screen)} aria-label="Starting up">
      <div className={styles.rings} aria-hidden>
        <svg width="220" height="220" viewBox="0 0 220 220">
          <circle
            className={styles.ringOuter}
            cx="110"
            cy="110"
            r="98"
            fill="none"
            strokeWidth="2"
            strokeDasharray="20 12"
          />
          <circle
            className={styles.ringInner}
            cx="110"
            cy="110"
            r="80"
            fill="none"
            strokeWidth="1"
            strokeDasharray="1 8"
          />
        </svg>
      </div>
      <div className={styles.brand}>
        <div className={styles.kicker}>EVESIX MEDICAL ROBOTICS</div>
        <h1 className={styles.wordmark}>EVESIX</h1>
        <div className={styles.version}>UV-C Field Sterilisation Control · v4.2.1</div>
      </div>
      <div
        className={styles.progress}
        role="progressbar"
        aria-label="System self-test"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
      >
        <div className={styles.progressFill} style={{ width: `${pct}%` }} />
      </div>
      <CheckList
        className={styles.checks}
        variant="boot"
        checks={BOOT_CHECKS}
        elapsed={phaseElapsed}
        lookahead={0.35}
        busyLastRow
      />
    </section>
  );
}
